import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 6;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    top: 10%;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  top: -500px;
  position: fixed;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 5px;
  padding: 20px 40px;
  visibility: hidden;
  transition: all 0.5s ease-out;

  h1 {
    font-weight: 500;
  }
  h2 {
    margin-left: 10px;
    color: #455a64;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  width: 100%;
  margin-bottom: 10px;

  h1 {
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  h2 {
    font-size: 20px;
    font-weight: 500;
  }
  hr {
    background-color: #cfd8dc;
    border: none;
    height: 2px;
    margin-top: 20px;
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;

  .input {
    display: flex;
    flex-direction: column;

    span {
      font-size: 16px;
      font-weight: 500;
      margin-right: 10px;
    }
  }

  .inputs-date {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 10px;

    .input-inputs {
      display: flex;
      flex-direction: column;

      span {
        font-size: 16px;
        font-weight: 500;
        margin-right: 10px;
      }

      .inputs-view {
        display: flex;
        align-items: center;
      }
      div:first-child {
        margin-right: 20px;
      }
    }

    div:first-child {
      margin-right: 50px;
    }
  }

  .buttons {
    display: flex;
    margin-top: 20px;

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-weight: 500;
      color: var(--azul-razio);
      border: 2px solid var(--azul-razio);
      border-radius: 10px;
      padding: 10px 30px;
    }

    button.save {
      background-color: var(--azul-razio);
      color: #fff;
    }

    button:first-child {
      margin-right: 10px;
    }
  }
`;
